import { IconButton, Stack, Tooltip } from '@mui/material';
import { useMemo } from 'react';
import { PopoverTrigger } from 'src/components/PopoverTrigger';
import Iconify from 'src/components/iconify';
import { useLocales } from 'src/locales';
import { useVoiceChannelContext } from 'src/provider/VoiceChannel';
import { useLivekitRTCState } from 'src/provider/VoiceChannel/livekit/useLivekitRTCState';

import {
  InputOutputSection,
  InputOutputSelector,
} from '@modules/input-output-devices/InputOutputSelector';
import { AITalk } from './AITalk';
import { ToggleMicControl } from './ToggleMicControl';

export const AICallControls = () => {
  const { translate } = useLocales();

  const { room, activeVoiceChannel, localParticipant } = useLivekitRTCState();

  const { setMuted } = useVoiceChannelContext();

  const muted = useMemo(() => localParticipant.muted, [localParticipant.muted]);
  const isConnected = useMemo(
    () => !!activeVoiceChannel?.channel?._id,
    [activeVoiceChannel?.channel?._id],
  );

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      gap={2}
      width={1}
    >
      <Stack direction="row" alignItems="center" gap={1} width={1}>
        <AITalk />
      </Stack>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="flex-end"
        gap={0.5}
      >
        <ToggleMicControl
          muted={muted}
          setMuted={setMuted}
          isSpeaking={room?.localParticipant.isSpeaking}
        />

        <PopoverTrigger
          popover={InputOutputSelector}
          context={{
            showSections: [
              InputOutputSection.MICROPHONE,
              InputOutputSection.SPEAKER,
            ],
          }}
        >
          <Tooltip
            placement="top"
            arrow
            title={translate('communicate.rtc_controls.device_settings')}
          >
            <span>
              <IconButton size="small" disabled={!isConnected}>
                <Iconify icon="tabler:dots-vertical" />
              </IconButton>
            </span>
          </Tooltip>
        </PopoverTrigger>
      </Stack>
    </Stack>
  );
};
